export const clearUserData = () => {
 localStorage.clear();
 sessionStorage.clear();
 document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
};
export const handleLogout = (navigate: (path: string) => void) => {
  clearUserData();
  navigate("/login");
};
